import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { UserService } from 'src/app/services/user.service';

interface User {
  id: number;
  name: string;
  osu_username: string;
  isMod: boolean;
  isAdmin: boolean;
}

export interface Comment {
  id: number;
  commented_id: number;
  comment: string;
  commented: any; // user
  created_at: Date;
  updated_at: Date;
  user: User;
  createdHumanReadable: string;
}

@Component({
  selector: 'app-comments-section',
  templateUrl: './comments-section.component.html',
  styleUrls: ['./comments-section.component.scss'],
})
export class CommentsSectionComponent implements OnInit {
  @Input()
  resourceName: 'bounties' | 'claims';
  @Input()
  id: number;
  @Input()
  comments: Comment[];
  @Input() ownerId: number;
  @Input() canComment = true;

  @Output()
  refetch = new EventEmitter<undefined>();

  public messageName = 'comment';
  public messageNamePlural = this.messageName + 's';
  public submitting = false;
  public commentText = '';
  public result: {
    color: 'green' | 'red';
    message: string;
  };
  public user: any;

  constructor(private apiService: ApiService, private userService: UserService) {
    this.user = userService.getUser();
  }

  ngOnInit() {
    this.messageName = this.resourceName === 'claims' ? 'message' : 'comment';
  }

  get messageClass() {
    if (!this.result) {
      return {};
    }

    return {
      [this.result.color]: true,
    };
  }

  public dismissMessage() {
    this.result = undefined;
  }

  public async submitComment() {
    this.submitting = true;
    try {
      await this.apiService
        .post(`${this.resourceName}/${this.id}/comments`, {
          comment: this.commentText,
        })
        .toPromise();
      this.commentText = '';
      this.result = {
        color: 'green',
        message: `Your ${this.messageName} has been posted`,
      };
      this.refetch.next();
    } catch (e) {
      switch (e.status) {
        case 429:
          this.result = {
            color: 'red',
            message:
              'You can only comment once per minute. Please wait a minute before leaving another.',
          };
          break;
        case 401:
          this.result = {
            color: 'red',
            message: 'You are not allowed to comment. Have you logged in?',
          };
          break;
        default:
          this.result = { color: 'red', message: 'A server error occured.' };
      }
    }

    this.submitting = false;
    setTimeout(() => {
      this.dismissMessage();
    }, 3000);
  }
}
